import { render, staticRenderFns } from "./index.vue?vue&type=template&id=06b2098f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=06b2098f&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b2098f')) {
      api.createRecord('06b2098f', component.options)
    } else {
      api.reload('06b2098f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=06b2098f&", function () {
      api.rerender('06b2098f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parse/3-28/index.vue"
export default component.exports